module.exports = __webpack_public_path__ + "media/images/contact/WS-sylvain-9be8dfe4cf0705e17e3373ad133292a2.jpg";